import { render } from "./AboutSimp.vue?vue&type=template&id=ff0f2db2"
import script from "./AboutSimp.vue?vue&type=script&lang=js"
export * from "./AboutSimp.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__